import React from "react";

const HMCTrio = () => {
  return (
    <svg
      width="60"
      height="61"
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_441_6523)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.8319 32.0583C26.2232 31.091 24.3804 30.5823 22.5032 30.5873L22.5 30.5873C16.5488 30.5873 11.4067 35.5885 9.93414 44.5598C9.82679 45.2138 9.20961 45.6569 8.55562 45.5496C7.90163 45.4422 7.45849 44.825 7.56583 44.1711C9.14314 34.5618 14.9129 28.1882 22.4984 28.1873C24.8183 28.1814 27.0954 28.8117 29.0821 30.0097L29.0934 30.0165L29.1983 30.0829C29.7582 30.4375 29.9246 31.1788 29.57 31.7387C29.2154 32.2986 28.4741 32.4651 27.9142 32.1105L27.8319 32.0583Z"
          fill="url(#paint0_radial_441_6523)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.2472 30.5748C40.2289 30.5724 39.2208 30.7777 38.2845 31.1781C37.6752 31.4388 36.9699 31.1561 36.7093 30.5468C36.4487 29.9374 36.7313 29.2322 37.3407 28.9715C38.5766 28.4429 39.9073 28.1718 41.2516 28.1748C46.9509 28.1756 51.2581 32.7579 52.4327 39.5677C52.5453 40.2208 52.1072 40.8416 51.4541 40.9542C50.801 41.0669 50.1802 40.6288 50.0676 39.9757C49.0172 33.886 45.3938 30.5748 41.2501 30.5748H41.2472V30.5748Z"
          fill="url(#paint1_radial_441_6523)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.6769 49.1608C23.8153 42.582 27.8208 38.7529 32.5531 38.7529C37.3009 38.7529 41.1913 42.6014 42.3231 49.1614C42.4358 49.8145 41.9977 50.4353 41.3446 50.548C40.6916 50.6606 40.0708 50.2226 39.9581 49.5695C38.9462 43.7044 35.7241 41.1529 32.5531 41.1529C29.3667 41.1529 26.0534 43.7238 25.0418 49.57C24.9288 50.2231 24.3078 50.6609 23.6548 50.5479C23.0017 50.4349 22.5639 49.8139 22.6769 49.1608Z"
          fill="url(#paint2_radial_441_6523)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.4998 13.0655C20.4974 13.0655 18.577 13.861 17.1611 15.2769C15.7452 16.6928 14.9498 18.6131 14.9498 20.6155C14.9498 22.6179 15.7452 24.5383 17.1611 25.9542C18.577 27.3701 20.4974 28.1655 22.4998 28.1655C24.5022 28.1655 26.4226 27.3701 27.8385 25.9542C29.2544 24.5383 30.0498 22.6179 30.0498 20.6155V13.0655H22.4998ZM15.4641 13.5798C17.3301 11.7138 19.8609 10.6655 22.4998 10.6655H32.4498V20.6155C32.4498 23.2544 31.4015 25.7853 29.5355 27.6512C27.6695 29.5172 25.1387 30.5655 22.4998 30.5655C19.8609 30.5655 17.3301 29.5172 15.4641 27.6512C13.5981 25.7853 12.5498 23.2544 12.5498 20.6155C12.5498 17.9766 13.5981 15.4458 15.4641 13.5798Z"
          fill="url(#paint3_radial_441_6523)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.2498 18.0624C39.9105 18.0624 38.626 18.5944 37.6789 19.5415C36.7319 20.4885 36.1998 21.773 36.1998 23.1124C36.1998 24.4517 36.7319 25.7362 37.6789 26.6832C38.626 27.6303 39.9105 28.1624 41.2498 28.1624C42.5892 28.1624 43.8736 27.6303 44.8207 26.6832C45.7678 25.7362 46.2998 24.4517 46.2998 23.1124V18.0624H41.2498ZM35.9819 17.8444C37.379 16.4473 39.2739 15.6624 41.2498 15.6624H48.6998V23.1124C48.6998 25.0882 47.9149 26.9832 46.5178 28.3803C45.1206 29.7774 43.2257 30.5624 41.2498 30.5624C39.2739 30.5624 37.379 29.7774 35.9819 28.3803C34.5847 26.9832 33.7998 25.0882 33.7998 23.1124C33.7998 21.1365 34.5847 19.2416 35.9819 17.8444Z"
          fill="url(#paint4_radial_441_6523)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.4998 30.5436C31.4091 30.5436 30.3631 30.9768 29.5918 31.7481C28.8206 32.5193 28.3873 33.5654 28.3873 34.6561C28.3873 35.7468 28.8206 36.7928 29.5918 37.564C30.3631 38.3353 31.4091 38.7686 32.4998 38.7686C33.5905 38.7686 34.6365 38.3353 35.4078 37.564C36.179 36.7928 36.6123 35.7468 36.6123 34.6561V30.5436H32.4998ZM27.8948 30.051C29.1161 28.8297 30.7726 28.1436 32.4998 28.1436H39.0123V34.6561C39.0123 36.3833 38.3262 38.0398 37.1048 39.2611C35.8835 40.4824 34.227 41.1686 32.4998 41.1686C30.7726 41.1686 29.1161 40.4824 27.8948 39.2611C26.6734 38.0398 25.9873 36.3833 25.9873 34.6561C25.9873 32.9288 26.6734 31.2724 27.8948 30.051Z"
          fill="url(#paint5_radial_441_6523)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_441_6523"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(38.9397 63.5667) rotate(-131.063) scale(60.0991 160.555)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_441_6523"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(59 54.2276) rotate(-130.158) scale(43.6605 116.071)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_441_6523"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(50.48 62.8016) rotate(-138.642) scale(46.6156 124.704)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_441_6523"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.6793 51.1786) rotate(-124.286) scale(62.8019 157.665)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_441_6523"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.8616 45.9963) rotate(-124.286) scale(47.0225 118.05)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_441_6523"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(44.3987 54.6603) rotate(-124.286) scale(41.1053 103.195)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <clipPath id="clip0_441_6523">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0 0.699951)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HMCTrio;
